import http, { AUTH_ROUTES } from "../../../services/api";
import { commodityUnit } from "../../../utils/commodityUnits";

// Normalizes one GET /users/payment-record row. The server follows a single
// rule for which bills are history (CONFIRMED/REFUNDED/under-review/in
// post-payment lifecycle); the client never filters or fabricates rows, it
// only reads the contract field names (with the legacy names as fallback).
export const normalizePaymentRecord = (row = {}) => {
  const commodity = String(row.commodity || row.commodityType || "").toUpperCase();
  const status = row.status || "";
  const underReview = row.underReview === true || row.statusLabel === "Under review";
  return {
    ...row,
    billId: row.billId || row._id,
    commodityType: commodity,
    commodity,
    unit: commodityUnit(commodity, row.unit),
    units: row.units ?? row.unitPurchased,
    unitPurchased: row.units ?? row.unitPurchased,
    amount: row.amount ?? row.amountPaid,
    amountPaid: row.amount ?? row.amountPaid,
    status,
    underReview,
    statusLabel: row.statusLabel || (status === "CONFIRMED" ? "Completed" : status === "REFUNDED" ? "Refunded" : underReview ? "Under review" : ""),
    token: status === "CONFIRMED" ? row.token || null : null,
  };
};

const pickList = (body) => {
  const candidates = [
    body?.data?.billsPayment,
    body?.data?.records,
    body?.data?.bills,
    body?.data?.items,
    body?.data,
    body?.userDetails?.data?.billsPayment,
    body?.userDetails?.data,
    body?.userDetails,
    body,
  ];
  return candidates.find((c) => Array.isArray(c)) || [];
};

const pickTotal = (body, fallback) => {
  const t = [
    body?.data?.totalRecords,
    body?.data?.total,
    body?.totalRecords,
    body?.total,
    body?.userDetails?.data?.totalRecords,
  ].find((n) => Number.isFinite(Number(n)) && n !== null && n !== undefined && n !== "");
  return t === undefined ? fallback : Number(t);
};

export const getPaymentRecord = async (
  paymentId,
  setPaymentRecord,
  setLoading,
  estateId,
  { limit = 10, skip = 0, commodityType, onError } = {},
  setTotalRecords,
) => {
  try {
    const result = await http.get(
      AUTH_ROUTES.GET_PAYMENT_RECORD(paymentId, estateId, { limit, skip, commodityType }),
    );
    const body = result?.data;
    const rows = pickList(body).map(normalizePaymentRecord);
    const total = pickTotal(body, rows.length);

    // If the server ignored skip/limit and returned the full list, page here
    // so pagination still works; never drop or invent rows.
    const paged = rows.length > limit ? rows.slice(skip, skip + limit) : rows;
    setPaymentRecord(paged);
    if (setTotalRecords) setTotalRecords(Math.max(total, rows.length));
    if (onError) onError(null);
  } catch (e) {
    console.error("getPaymentRecord error", e?.response || e?.message || e);
    setPaymentRecord([]);
    if (setTotalRecords) setTotalRecords(0);
    if (onError) onError("We couldn't load your payment history. Please try again.");
  } finally {
    setLoading(false);
  }
};
